define('views/modules/calendar/animated-session/session/session-week-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // events
    'services/events/calendar-events',
    'services/events/animated-session-events',
    // services
    'services/layout',
    'services/user',
    'services/app-state',
    'services/i18n',
    // parts views
    'views/parts/menu/menu-save-action',
    'views/parts/alert/alert-list',
    // views
    'views/modules/calendar/animated-session/exercise/lists/week-brief/week-exercise-list',
    'views/modules/calendar/animated-session/exercise/edit/exercise-edit-panel',
    'views/modules/calendar/calendar-item-panel-content',
    'views/modules/calendar/calendar-item-daily-stats',
    // Templates Blocks
    'text!templates/modules/calendar/animated-session/session/session-week-content.html'
], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // events
    CalendarEvents,
    AnimationEvents,
    // services
    LayoutState,
    User,
    AppState,
    i18n,
    // parts views
    VMenuSaveAction,
    VAlertList,
    // views
    VWeekExerciseList,
    VExerciseEditPanel,
    VCalendarItemPanelContent,
    VCalendarItemDailyStats,
    // Template
    TSessionWeekContent
) {

    var VSessionWeekContent = VCalendarItemPanelContent.extend({
        contentTemplate: TSessionWeekContent,
        exerciseListView: VWeekExerciseList,
        fields: VCalendarItemPanelContent.prototype.fields.concat(
            ['duration', 'calories', 'distance']
        ),

        events: {
            'click .session-notes a': "onClickLink"
        },

        // abstracting selectors out of the view logic
        regions: _.extend(VCalendarItemPanelContent.prototype.regions, {
            list: "#session-week-list",
            stats: ".item-stats",
            notes: ".session-notes",
            alert: ".alert-list"
        }),

        initialize: function(opt) {
            opt = this.options = _.extend({}, opt);
            VSessionWeekContent.__super__.initialize.call(this, opt);

            this.profile = opt.profile;

            var model = this.model,
                session = this.session = opt.session,
                collection = this.collection = session.getExerciseCollection(),
                view = _.extend(this.view, {
                    list: new this.exerciseListView({
                        model: session,
                        role: opt.role,
                        collection: collection,
                        item: model,
                        summary: true,
                        sortable: false
                    }),
                    stats: new VCalendarItemDailyStats({
                        model: this.model
                    }),
                    alert: new VAlertList({ dismissable: false })
                });

            _.extend(this, {
                collectionCopy: collection.toJSON({ blacklist: true }),
                bindingSources: { session: session }
            });

            this.caloriesValueChangeManually = false;
            this.minutesValueChangeManually = false;

            if (User.get('_canViewAnimatedSessions') && AppState.onClientSide()) {
                view.menu.addMoreActions([
                    { icon: 'fa fa-edit', caption: 'calendar:Edit this session', callback: this.onEditActionClick, context: this }
                ]);
            }

            this.listenTo(this.modelMaster, 'change', this.onMasterChanged);

            this.listenTo(collection, {
                'exercise:edit': this.onExerciseEdit,
                'change update': this.onCollectionChange,
                'change:sets': this.onSessionChange,
                'change:done': this.onExerciseDoneChange,
                'reset': this.onCollectionReset
            });

            this.listenTo(session, {
                'change': this.onSessionChange,
                'sync': this.onSessionSync,
                'model:reset': this.onSessionReset
            });
        },

        render: function() {
            VSessionWeekContent.__super__.render.apply(this, arguments);
            var view = this.view,
                zone = this.zone;

            this.assign(view.list, zone.$list, { defer: true })
                .assign(view.stats, zone.$stats)
                .assign(view.alert, zone.$alert);

            this.toggleNotes()
                .applyBindings();

            this.view.alert.reset();

            if (this.userCanSeeAlert()) {
                this.view.alert.addInfo(i18n.t('calendar:this-item-is-hidden'));
            }

            return this;
        },

        initListener: function() {
            VSessionWeekContent.__super__.initListener.apply(this, arguments);
            this.stopListeningTo(AnimationEvents);
            this.listenTo(AnimationEvents, {
                'session:item:done': this.onSessionItemDone,
            });
            this.listenTo(AnimationEvents, {
                'session:statsKeypress': this.onStatsKeypress,
            });
            this.listenTo(AnimationEvents, {
                'exercise:saveAndNext': this.onSaveAndNext,
            });

        },

        isDirty: function() {
            return VSessionWeekContent.__super__.isDirty.apply(this, arguments) ||
                this.hasCollectionChanged();
        },

        resetExerciseCollection: function() {
            this.session.resetExerciseCollection();
            return this;
        },

        toggleExercisesDone: function(value) {
            var done = typeof value !== "undefined" ? value : !this.model.isDone();
            this.session.getExerciseCollection().each(function(model) {
                model.setWeekDone(this.model.get('week'), done);
            }, this);
        },

        toggleNotes: function() {
            this.zone.$notes.toggle(Boolean(this.session.getNotes()));
            return this;
        },

        saveSession: function(closePanelOnSuccess) {
            var session = this.session;

            if (this.hasCollectionChanged()) {
                if (session.changedAttributes() !== undefined && session.changedAttributes() !== false) {
                    session.save(session.changedAttributes(), {
                        patch: true,
                        wait: true,
                        context: this,
                        success: function() {
                            CalendarEvents.sessionUpdate(this.session.clone(), this.options.url);
                            this.save();

                            if (this.submitFromSave && (typeof closePanelOnSuccess === 'undefined' ||  closePanelOnSuccess)) {
                                this.trigger('save:button:form:success');
                            }
                        }
                    });
                }
            }
        },


        setExercises: function() {
            var collection = this.collection;
            if (this.hasCollectionChanged()) {
                collection.setLoadUnit();
                this.session.setExercises(collection.toJSON({ blacklist: true }));
            }
        },

        setAsDoneIfLoadsFullyComplete: function() {
          var calSessionDate = this.model.get("date");
          var toDate = new Date();
          //Si date ulterieur a date/heure courante ou si c'est deja DONE, pas besoin de verifier just quit
          if (new Date(calSessionDate).getTime() >= toDate.getTime() || this.model.isDone()) return;

          var weekIndex = this.model.getWeek();
          var allLoadsFill = true;
          var arrExercices = this.session.getExerciseCollection();

          for (var i = 0; i < arrExercices.length; i++) {
              allLoadsFill = true;

              var arrSets = arrExercices.models[i].get("weeks").models[weekIndex].get("sets");
              for (var j = 0; j < arrSets.length; j++) {
                  if (arrSets.models[j].get("load").value <= 0) {
                    allLoadsFill = false;
                    break;
                  }
              }

              if (allLoadsFill) {
                  this.onExerciseDoneChange(true);
              }
          }
        },

        hasCollectionChanged: function() {
            return !this.collection.equals(this.collectionCopy);
        },

        computeWeightTypeAnimationStats: function() {
          //Get all Exercises of Weight type
          var colExercices = this.session.getExerciseCollection().filter(function(model) { return model.get('type') === 'weight'; });
          var userDistanceUnit = User.get("units").distance;
          var stats = { duration: 0, trainingDuration: 0, calories: 0, distance: { unit: userDistanceUnit, value: 0 } };
          var exercice, week, tmpStats;
          for (var i = 0; i < colExercices.length; i++) {
              exercice = colExercices[i];
              week = exercice.getWeek(this.options.model.getWeek());
              if (week.isDone()) {
                    tmpStats = { duration: 0, trainingDuration: 0, calories: 0, distance: { unit: userDistanceUnit, value: 0 } };
                    var numSets = this.getNumSets(exercice, week);
                    var multiplier = this.getMultiplier(exercice, numSets);

                    for (var j = 0; j < numSets; j++) {
                      var set = week.getSets().at(j);
                      var duration = exercice.get("repsType") === "secs" ? parseInt(this.getDuration(exercice.get("repsType"), set.get('reps'))) : this.getDuration(exercice.get("repsType"), set.get('reps'));
                      var distance = { unit: userDistanceUnit, value: this.getDistance(exercice.get("repsType"), set.get('reps'), userDistanceUnit) };

                      if (duration > 0) {
                        tmpStats.duration += duration + set.get('rest');
                        tmpStats.trainingDuration += duration;
                      }

                      tmpStats.distance.value += distance.value;
                    }
                    tmpStats.duration *= multiplier;
                    tmpStats.trainingDuration *= multiplier;

                    tmpStats.calories = this.getCalories(tmpStats.trainingDuration, exercice);

                    stats.calories += tmpStats.calories;
                    stats.trainingDuration += tmpStats.trainingDuration;
                    stats.duration += tmpStats.duration;
                    stats.distance.value += tmpStats.distance.value;

            }
          }
          this.setModelStats(stats);
        },

        getEffortZone: function(animation, zoneNbr) {
          return animation.zones[zoneNbr] || 0.09436;  //Default value if zone is undefined
        },

        getCalories: function(trainingDuration, exercice) {
          var cal = 0;

          if (User.getWeightValue("kg"))
              cal = trainingDuration / 60 * User.getWeightValue("kg") * this.getEffortZone(exercice.getAnimation(), 5);

          return cal;
        },

        getNumSets: function(exercice, week) {
            var val = 0;
            if (exercice.hasMultiRep())
              val = week.getSets().length;
            else
              val = 1;

            return val;
        },

        getMultiplier: function(exercice, numSets) {
            var val = 0;
            if (exercice.hasMultiRep())
              val = 1;
            else
              val = numSets;

            return val;
        },

        setModelStats: function(stats) {
          if (!this.caloriesValueChangeManually){ //If Changed manually, we don't set it automaticly on DONE event
              this.model.set("calories", Math.round(stats.calories));
          }
          if (!this.minutesValueChangeManually){ //If Changed manually, we don't set it automaticly on DONE event
              this.model.set("duration", stats.duration);
          }
          this.model.set("distance", { unit: stats.distance.unit, value: stats.distance.value });
        },

        getDistance: function(repsType, repValue, userDistanceUnit) {
          var distance = 0;
          if (repsType === 'km' || repsType === 'miles' || repsType === 'mi') {
            distance = User.convertDistanceTo(repsType, repValue, userDistanceUnit);
          }
          return distance;
        },

        getDuration: function(repsType, repValue) {
          var duration = 0;
          switch (repsType) {
            case 'secs':
              duration = repValue;
              break;
            case 'mins':
              duration = 60 * repValue;
              break;
            case 'reps':
              duration = 60;
              break;
          }
          return duration;
        },
        /////////////
        // Actions //
        /////////////


        onMasterChanged: function()  {
            this.setPristine();
        },

        onSaveAndNext: function(model, closePanelAfter) {
            //Since the model is a clone, we cannot update the collection directly.
            //We must remove the model to update before adding the modified one.
            this.submitFromSave = closePanelAfter;

            this.saveExercise(model, closePanelAfter);

            this.onExerciseDoneChange(true);
            this.view.list.render();

            if (closePanelAfter) {
                AnimationEvents.exerciseEditFinish(model);
            }

        },

        isModelsTheSame: function(model, ex) {
            return model.get("animatedExercise") === ex.get("animatedExercise") &&
                model.get("index") === ex.get("index") && model.get("weeks").length === ex.get("weeks").length;
        },

        saveExercise: function(model, closePanelAfter) {
            var exerciseToUpdate = this.collection.get({ cid: model.get("oldCid") });
            var ex = null;
            for (var i = 0; i < this.collection.length; i++) {
                ex = this.collection.models[i];
                if (this.isModelsTheSame(model, ex)) {
                    exerciseToUpdate = ex;
                    break;
                }
            }

            exerciseToUpdate.reset(model.attributes);
            this.setExercises();
            this.saveSession(closePanelAfter);

        },

        onStatsKeypress: function(model, inputName, key, value) {
          if (inputName === 'calories') // && value !== this.model.get('calories'))
            this.caloriesValueChangeManually = true;

          if (inputName === 'duration') // && value !== this.model.get('duration'))
            this.minutesValueChangeManually = true;
        },

        onDone: function(opt) {
            opt = _.extend({}, {
                toggleExercises: true
            }, opt);

            if (opt.toggleExercises) this.toggleExercisesDone();

            if (this.model.get("type") === "animated") this.computeWeightTypeAnimationStats(); //Update Calories/duration/distance

            VSessionWeekContent.__super__.onDone.call(this, opt);
            if (this.hasCollectionChanged()) {
                this.saveSession();
            }
        },

        onSaveClick: function() {
            VSessionWeekContent.__super__.onSaveClick.apply(this, arguments);
            this.saveSession();

            this.caloriesValueChangeManually = false;
            this.minutesValueChangeManually = false;
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onEditActionClick: function() {
            var session = this.session,
                opt = this.options;
            Backbone.history.navigate(
                Mustache.render(opt.url, {
                    userId: opt.profile.id,
                    groupId: opt.group.id,
                    conversationId: opt.conversationId,
                    dayId: session.getDate(),
                    sessionId: session.id,
                }), { trigger: true });
        },

        userCanSeeAlert: function() {
            if (! User.getSupervisorGroup().daysBeforeCalendarItemsAreHidden || this.model.isNew() || this.model.get('isVisible')) {
                return false;
            }

            return this.model.isAfterDays(User.getSupervisorGroup().daysBeforeCalendarItemsAreHidden);
        },

        ////////////
        // events //
        ////////////

        onCollectionReset: function() {
            this.collectionCopy = this.collection.toJSON({ blacklist: true });
            this.onCollectionChange();
            this.view.alert.reset();

            if (this.userCanSeeAlert()) {
                this.view.alert.addInfo(i18n.t('calendar:this-item-is-hidden'));
            }
        },

        onSubmit: function() {
            this.setExercises();
        },

        onValidate: function() {
            var result = this.collection.isValid();
            if (!result) {
                this.collection.each(function(model) {
                    U.warn(model.validationError);
                });
            }
            return result;
        },

        onCollectionChange: function() {
            this.view.menu.toggleSaveButton(!this.isDirty());
        },

        onSessionItemDone: function(session, item, value) {
            this.toggleExercisesDone(value);
            if (this.model.get("type") === "animated") {
              this.computeWeightTypeAnimationStats(); //Update Calories/duration/distance
              this.model.save();
              this.save();
            }
            if (session.is(this.session)) {
                this.session.reset(session.attributes);
            }
        },

        onExerciseDoneChange: function(value) {
            var allWeekDone = this.collection.getAllWeekDone(this.model.getWeek());

            if (_.isEmpty(_.filter(allWeekDone, function(done) { return done === false; })) && value) { // is last checked (set as done)
                this.onDone({ toggleExercises: false, toggle: true });
            } else if (_.isEmpty(_.filter(allWeekDone, function(done) { return done === true; })) && !value) { // is last unchecked (not done)
                this.onDone({ toggleExercises: false, toggle: false });
            }
            if (this.model.get("type") === "animated") this.computeWeightTypeAnimationStats(); //Update Calories/duration/distance
            this.onModelChange();
        },

        onExerciseEdit: function(model) {
            var view = this.view,
                panel = view.edit;
            if (!panel) {
                panel = this.view.edit = new VExerciseEditPanel({
                    session: this.session,
                    item: this.model,
                    profile: this.profile,
                    model: model
                });

                this.listenTo(panel, 'form:success', this.onExerciseEditSuccess);
                this.listenTo(panel, 'exercise:done', this.onExerciseDone);
            }

            AnimationEvents.exerciseEditBegin(model);
            panel.setModel(model);
            LayoutState.stackInfo(panel);
        },

        onExerciseEditSuccess: function(model) {
            this.saveExercise(model, false);
            this.view.list.render();
        },

        onExerciseDone: function(model) {
            this.onExerciseDoneChange(true);
        },

        onSessionChange: function(model, options) {
            this.onModelChange(model, options);
        },

        // onSessionSync: function() {
        //     this.resetExerciseCollection()
        //         .toggleNotes();
        // },

        // onSessionReset: function(model) {
        //     this.resetExerciseCollection();
        // },

        onDisable: function() {
            VSessionWeekContent.__super__.onDisable.apply(this, arguments);
            this.stopListeningTo(AnimationEvents);
        },

        onClickLink: function(e) {
            // Open in system browser on native platforms
            if (window.Capacitor && window.Capacitor.isNativePlatform()) {
                e.preventDefault();
                window.open(e.target.href, '_system');
            }
        }

    });

    return VSessionWeekContent;

});

